import { A } from '../actions/packing';
import update from 'immutability-helper';

const initialState = {
  getPackingControl: {
    isFetching: false,
    error: null,
  },
  sendPackingControl: {
    isFetching: false,
    error: null,
  },
  updateSinglePacking: {
    isFetching: false,
    error: null,
  },
  updatePackingBatch: {
    isFetching: false,
    error: null,
  },
  getPickupDates: {
    isFetching: false,
    error: null,
  },
  getTakeoutLists: {
    isFetching: false,
    error: null,
  },
  updateTakeoutList: {
    isFetching: false,
    error: null,
  },
  getTakeoutPrint: {
    isFetching: false,
    error: null,
  },
  addFbmTextSticker: {
    isFetching: false,
    error: null,
  },
  addFbmPdfSticker: {
    isFetching: false,
    error: null,
  },
};

const packing = (state = initialState, action) => {
  switch (action.type) {
    case A.REQUEST_GET_PACKING_CONTROL:
      return update(state, {
        getPackingControl: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_PACKING_CONTROL:
      return update(state, {
        getPackingControl: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_GET_PACKING_CONTROL:
      return update(state, {
        getPackingControl: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_SEND_PACKING_CONTROL:
      return update(state, {
        sendPackingControl: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_SEND_PACKING_CONTROL:
      return update(state, {
        sendPackingControl: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_SEND_PACKING_CONTROL:
      return update(state, {
        sendPackingControl: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_UPDATE_SINGLE_PACKING:
      return update(state, {
        updateSinglePacking: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_UPDATE_SINGLE_PACKING:
      return update(state, {
        updateSinglePacking: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_UPDATE_SINGLE_PACKING:
      return update(state, {
        updateSinglePacking: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_UPDATE_PACKING_BATCH:
      return update(state, {
        updateSinglePacking: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_UPDATE_PACKING_BATCH:
      return update(state, {
        updateSinglePacking: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_UPDATE_PACKING_BATCH:
      return update(state, {
        updateSinglePacking: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_PICKUP_DATES:
      return update(state, {
        getPickupDates: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_PICKUP_DATES:
      return update(state, {
        getPickupDates: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_GET_PICKUP_DATES:
      return update(state, {
        getPickupDates: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_TAKEOUT_LISTS:
      return update(state, {
        getTakeoutLists: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_TAKEOUT_LISTS:
      return update(state, {
        getTakeoutLists: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_GET_TAKEOUT_LISTS:
      return update(state, {
        getTakeoutLists: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_UPDATE_TAKEOUT_LIST:
      return update(state, {
        updateTakeoutList: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_UPDATE_TAKEOUT_LIST:
      return update(state, {
        updateTakeoutList: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_UPDATE_TAKEOUT_LIST:
      return update(state, {
        updateTakeoutList: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_TAKEOUT_PRINT:
      return update(state, {
        getTakeoutPrint: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_TAKEOUT_PRINT:
      return update(state, {
        getTakeoutPrint: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_GET_TAKEOUT_PRINT:
      return update(state, {
        getTakeoutPrint: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_ADD_FBM_TEXT_STICKER:
      return update(state, {
        addFbmTextSticker: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_ADD_FBM_TEXT_STICKER:
      return update(state, {
        addFbmTextSticker: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_ADD_FBM_TEXT_STICKER:
      return update(state, {
        addFbmTextSticker: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_ADD_FBM_PDF_STICKER:
      return update(state, {
        addFbmPdfSticker: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_ADD_FBM_PDF_STICKER:
      return update(state, {
        addFbmPdfSticker: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_ADD_FBM_PDF_STICKER:
      return update(state, {
        addFbmPdfSticker: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    default:
      return state;
  }
};

export default packing;
